module.exports = __webpack_public_path__ + "img/Left.2e8dfb06.png";